import { render, staticRenderFns } from "./MenuRoleComp.vue?vue&type=template&id=3d11480f&scoped=true&"
import script from "./MenuRoleComp.vue?vue&type=script&lang=ts&"
export * from "./MenuRoleComp.vue?vue&type=script&lang=ts&"
import style0 from "./MenuRoleComp.vue?vue&type=style&index=0&id=3d11480f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11480f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCol,VContainer,VRow,VTooltip})
